import styled from 'styled-components';

export const AutoMargin = styled.div`
  margin: 0 auto;
`;
